import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    return (
        <div id="outdoor-recreation-G" className={`outdoor-recreation-G ${css['outdoor-recreation-G']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/outdoor-recreation/7.jpg"
                    srcDesktop="/responsive/picture/outdoor-recreation/7_1366.jpg"
                    srcPad="/responsive/picture/outdoor-recreation/7_768.jpg"
                    srcMobile="/responsive/picture/outdoor-recreation/7_375.jpg"
                    alt={t('secG_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secG_title')}</p>
                    <p className="desc">{t('secG_desc')}</p>
                    <div className="tags">
                        <span className="tag">{t('secG_tag1')}</span>
                        <span className="tag">{t('secG_tag2')}</span>
                        <span className="tag">{t('secG_tag3')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
